
(function () {
  function initMainHeadingSticky() {
    var roots = document.querySelectorAll('[data-cl-selector]');

    if (!roots.length) return;

    var ticking = false;

    function getHeight(selector) {
      var el = document.querySelector(selector);

      if (!el) return 0;

      var style = window.getComputedStyle(el);

      if (style.display === 'none' || style.visibility === 'hidden') {
        return 0;
      }

      return el.offsetHeight || 0;
    }

    function getStickyTriggerHeight() {
      var announcementHeight = getHeight('.announcement-bar');
      var headerHeight = getHeight('.custom-header-section');
      var bannerHeight = getHeight('.main-banner');

      return announcementHeight + headerHeight + bannerHeight;
    }

    function updateStickyBar() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var triggerHeight = getStickyTriggerHeight();

      roots.forEach(function (root) {
        var stickyBar = root.querySelector('.main-heading-list');

        if (!stickyBar) return;

        var stickyHeight = stickyBar.offsetHeight || 0;

        root.style.setProperty('--main-heading-list-height', stickyHeight + 'px');

        if (scrollTop >= triggerHeight) {
          stickyBar.classList.add('top-sticky');
          root.classList.add('has-top-sticky');
        } else {
          stickyBar.classList.remove('top-sticky');
          root.classList.remove('has-top-sticky');
        }
      });

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateStickyBar);
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', updateStickyBar);

    updateStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainHeadingSticky);
  } else {
    initMainHeadingSticky();
  }
})();

(() => {
  "use strict";

  const DESKTOP_BREAKPOINT = 990;
  let bootAttempts = 0;

  function initializeGallery(root) {
    const $ = window.jQuery;

    if (
      !root ||
      root.dataset.slickInitialized === "true" ||
      typeof $ !== "function" ||
      typeof $.fn.slick !== "function"
    ) {
      return;
    }

    root.dataset.slickInitialized = "true";

    const $root = $(root);
    const $main = $root.find("[data-slick-main]");
    const $thumbs = $root.find("[data-slick-thumbnails]");

    const mediaCount =
      Number(root.dataset.mediaCount) || $main.children().length;

    const initialSlide =
      Number(root.dataset.initialSlide) || 0;

    const visibleThumbnails = Math.min(7, mediaCount);

    /*
     * Store media positions before Slick changes the markup.
     */
    const mediaIndexes = {};

    $main.children("[data-media-id]").each(function (index) {
      mediaIndexes[String(this.dataset.mediaId)] = index;
    });

    let variantMediaMap = {};

    const variantMediaJson = root.querySelector(
      "[data-variant-media-map]"
    );

    if (variantMediaJson) {
      try {
        variantMediaMap = JSON.parse(
          variantMediaJson.textContent
        );
      } catch (error) {
        console.warn(
          "Product gallery: invalid variant media JSON.",
          error
        );
      }
    }

    function pauseInactiveMedia(activeSlide) {
      $main.find("video").each(function () {
        if (!activeSlide || !activeSlide.contains(this)) {
          this.pause();
        }
      });
    }

    $main.on(
      "afterChange",
      function (event, slick, currentSlide) {
        const activeSlide =
          slick.$slides.get(currentSlide);

        pauseInactiveMedia(activeSlide);
      }
    );

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide,
      infinite: false,
      arrows: false,
      dots: false,
      fade: true,
      speed: 350,
      cssEase: "ease",
      adaptiveHeight: false,
      accessibility: true,
      swipe: true,
      draggable: true,
      waitForAnimate: false,
      asNavFor:
        mediaCount > 1
          ? `#${$thumbs.attr("id")}`
          : null
    });

    function updateThumbnailHeight() {
      if (!$thumbs.length) {
        return;
      }

      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        $thumbs.css("height", "");

        if ($thumbs.hasClass("slick-initialized")) {
          $thumbs.slick("setPosition");
        }

        return;
      }

      const mainHeight = Math.ceil(
        $main.find(".slick-list").outerHeight()
      );

      if (mainHeight > 0) {
        $thumbs.height(mainHeight);

        if ($thumbs.hasClass("slick-initialized")) {
          $thumbs.slick("setPosition");
        }
      }
    }

    if (mediaCount > 1 && $thumbs.length) {
      $thumbs.slick({
        slidesToShow: visibleThumbnails,
        slidesToScroll: 1,
        initialSlide,
        infinite: false,
        arrows: false,
        dots: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        swipeToSlide: true,
        draggable: true,
        speed: 300,
        accessibility: true,
        waitForAnimate: false,
        asNavFor: `#${$main.attr("id")}`,
        responsive: [
          {
            breakpoint: DESKTOP_BREAKPOINT,
            settings: {
              slidesToShow: Math.min(5, mediaCount),
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false,
              swipeToSlide: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: Math.min(4, mediaCount),
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false,
              swipeToSlide: true
            }
          }
        ]
      });

      /*
       * Mouse-wheel navigation for desktop thumbnails.
       */
      $thumbs.on("wheel", function (event) {
        if (
          window.innerWidth < DESKTOP_BREAKPOINT ||
          mediaCount <= visibleThumbnails
        ) {
          return;
        }

        event.preventDefault();

        if (event.originalEvent.deltaY > 0) {
          $thumbs.slick("slickNext");
        } else {
          $thumbs.slick("slickPrev");
        }
      });
    }

    window.requestAnimationFrame(() => {
      updateThumbnailHeight();

      $main.slick("setPosition");

      if ($thumbs.hasClass("slick-initialized")) {
        $thumbs.slick("setPosition");
      }
    });

    let resizeTimer = null;

    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(() => {
        updateThumbnailHeight();

        if ($main.hasClass("slick-initialized")) {
          $main.slick("setPosition");
        }
      }, 120);
    });

    /*
     * Move to the selected variant's featured media.
     */
    function showVariantMedia() {
      const formId = root.dataset.productFormId;

      if (!formId) {
        return;
      }

      const productForm = document.getElementById(formId);

      if (!productForm) {
        return;
      }

      const variantInput = productForm.querySelector(
        '[name="id"]'
      );

      if (!variantInput || !variantInput.value) {
        return;
      }

      const variantId = String(variantInput.value);
      const mediaId = String(
        variantMediaMap[variantId] || 0
      );

      if (
        mediaId === "0" ||
        typeof mediaIndexes[mediaId] === "undefined"
      ) {
        return;
      }

      $main.slick(
        "slickGoTo",
        mediaIndexes[mediaId],
        false
      );
    }

    const sectionElement =
      root.closest(".shopify-section") ||
      root.parentElement;

    if (sectionElement) {
      sectionElement.addEventListener("change", () => {
        window.setTimeout(showVariantMedia, 60);
      });
    }

    document.addEventListener(
      "variant:change",
      showVariantMedia
    );

    document.addEventListener(
      "variant:changed",
      showVariantMedia
    );

    document.addEventListener(
      "product:variant-change",
      showVariantMedia
    );
  }

  function initializeAllGalleries(scope = document) {
    scope
      .querySelectorAll("[data-product-slick-gallery]")
      .forEach(initializeGallery);
  }

  function bootSlickGalleries() {
    const $ = window.jQuery;

    if (
      typeof $ !== "function" ||
      typeof $.fn.slick !== "function"
    ) {
      bootAttempts += 1;

      if (bootAttempts < 100) {
        window.setTimeout(bootSlickGalleries, 50);
      } else {
        console.error(
          "Product gallery: jQuery or Slick failed to load."
        );
      }

      return;
    }

    initializeAllGalleries();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      bootSlickGalleries
    );
  } else {
    bootSlickGalleries();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      window.setTimeout(() => {
        initializeAllGalleries(event.target);
      }, 50);
    }
  );
})();

//--- jquery FOr the Modal --//
(function () {
  'use strict';

  /* --------------------------------------------------
   * Global iPhone popup configuration
   * -------------------------------------------------- */
  const POPUP_ID = 'cl-iphone-popup';

  /*
   * Both options will open the popup:
   * 1. class="iphone-popup-trigger"
   * 2. data-iphone-popup-open
   */
  const OPEN_SELECTOR =
    '.iphone-popup-trigger, [data-iphone-popup-open]';

  const CLOSE_SELECTOR = '[data-iphone-popup-close]';

  const SCROLL_LOCK_CLASS = 'cl-iphone-popup-open';

  let activeTrigger = null;

  /* --------------------------------------------------
   * Get the global popup
   * -------------------------------------------------- */
  function getPopup() {
    return document.getElementById(POPUP_ID);
  }

  /* --------------------------------------------------
   * Get popup dialog
   * -------------------------------------------------- */
  function getDialog(popup) {
    if (!popup) {
      return null;
    }

    return popup.querySelector('[role="dialog"]');
  }

  /* --------------------------------------------------
   * Get focusable elements inside popup
   * -------------------------------------------------- */
  function getFocusableElements(popup) {
    if (!popup) {
      return [];
    }

    const selectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ];

    return Array.from(
      popup.querySelectorAll(selectors.join(','))
    ).filter(function (element) {
      return (
        element.offsetWidth > 0 ||
        element.offsetHeight > 0 ||
        element.getClientRects().length > 0
      );
    });
  }

  /* --------------------------------------------------
   * Update all trigger aria attributes
   * -------------------------------------------------- */
  function updateTriggerStates(openTrigger) {
    const triggers = document.querySelectorAll(OPEN_SELECTOR);

    triggers.forEach(function (trigger) {
      const isActive = trigger === openTrigger;

      trigger.setAttribute(
        'aria-expanded',
        isActive ? 'true' : 'false'
      );

      if (!trigger.hasAttribute('aria-controls')) {
        trigger.setAttribute('aria-controls', POPUP_ID);
      }
    });
  }

  /* --------------------------------------------------
   * Lock page scrolling
   * -------------------------------------------------- */
  function lockPageScroll() {
    document.documentElement.classList.add(
      SCROLL_LOCK_CLASS
    );

    document.body.classList.add(
      SCROLL_LOCK_CLASS
    );
  }

  /* --------------------------------------------------
   * Unlock page scrolling
   * -------------------------------------------------- */
  function unlockPageScroll() {
    document.documentElement.classList.remove(
      SCROLL_LOCK_CLASS
    );

    document.body.classList.remove(
      SCROLL_LOCK_CLASS
    );
  }

  /* --------------------------------------------------
   * Open popup
   * -------------------------------------------------- */
  function openPopup(trigger) {
    const popup = getPopup();

    if (!popup) {
      console.warn(
        'iPhone popup not found. Add id="cl-iphone-popup" to the popup.'
      );

      return;
    }

    /*
     * Save the clicked trigger so focus can return
     * to it when the popup closes.
     */
    activeTrigger =
      trigger instanceof HTMLElement
        ? trigger
        : document.activeElement;

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    updateTriggerStates(trigger);
    lockPageScroll();

    const dialog = getDialog(popup);
    const focusableElements =
      getFocusableElements(popup);

    /*
     * Wait until the popup becomes visible,
     * then move keyboard focus inside it.
     */
    window.requestAnimationFrame(function () {
      if (dialog) {
        /*
         * Add tabindex only when missing.
         */
        if (!dialog.hasAttribute('tabindex')) {
          dialog.setAttribute('tabindex', '-1');
        }

        dialog.focus();
      } else if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    });

    /*
     * Optional event for other custom scripts.
     */
    document.dispatchEvent(
      new CustomEvent('iphonePopup:opened', {
        detail: {
          popup: popup,
          trigger: trigger
        }
      })
    );
  }

  /* --------------------------------------------------
   * Close popup
   * -------------------------------------------------- */
  function closePopup() {
    const popup = getPopup();

    if (!popup || popup.hidden) {
      return;
    }

    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');

    updateTriggerStates(null);
    unlockPageScroll();

    /*
     * Return focus to the button or link
     * that opened the popup.
     */
    if (
      activeTrigger &&
      typeof activeTrigger.focus === 'function'
    ) {
      activeTrigger.focus();
    }

    document.dispatchEvent(
      new CustomEvent('iphonePopup:closed', {
        detail: {
          popup: popup
        }
      })
    );

    activeTrigger = null;
  }

  /* --------------------------------------------------
   * Keep keyboard focus inside open popup
   * -------------------------------------------------- */
  function trapFocus(event) {
    const popup = getPopup();

    if (
      !popup ||
      popup.hidden ||
      event.key !== 'Tab'
    ) {
      return;
    }

    const focusableElements =
      getFocusableElements(popup);

    if (focusableElements.length === 0) {
      event.preventDefault();

      const dialog = getDialog(popup);

      if (dialog) {
        dialog.focus();
      }

      return;
    }

    const firstElement = focusableElements[0];

    const lastElement =
      focusableElements[
        focusableElements.length - 1
      ];

    /*
     * Shift + Tab from the first element
     * moves focus to the last element.
     */
    if (
      event.shiftKey &&
      document.activeElement === firstElement
    ) {
      event.preventDefault();
      lastElement.focus();

      return;
    }

    /*
     * Tab from the last element
     * moves focus to the first element.
     */
    if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  /* --------------------------------------------------
   * Global click events
   *
   * Event delegation means triggers added later by
   * Shopify sections will also work automatically.
   * -------------------------------------------------- */
  document.addEventListener('click', function (event) {
    const openTrigger = event.target.closest(
      OPEN_SELECTOR
    );

    if (openTrigger) {
      event.preventDefault();
      openPopup(openTrigger);

      return;
    }

    const closeTrigger = event.target.closest(
      CLOSE_SELECTOR
    );

    if (closeTrigger) {
      event.preventDefault();
      closePopup();

      return;
    }

    const popup = getPopup();

    /*
     * Close when clicking the empty popup overlay.
     * This works when the outer popup itself is
     * used as the dark backdrop.
     */
    if (
      popup &&
      !popup.hidden &&
      event.target === popup
    ) {
      closePopup();
    }
  });

  /* --------------------------------------------------
   * Keyboard events
   * -------------------------------------------------- */
  document.addEventListener('keydown', function (event) {
    const popup = getPopup();

    if (!popup || popup.hidden) {
      return;
    }

    /*
     * Close with Escape.
     */
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();

      return;
    }

    trapFocus(event);
  });

  /* --------------------------------------------------
   * Initialize popup attributes
   * -------------------------------------------------- */
  function initializePopup() {
    const popup = getPopup();

    if (!popup) {
      return;
    }

    if (popup.hidden) {
      popup.setAttribute('aria-hidden', 'true');
    } else {
      popup.setAttribute('aria-hidden', 'false');
    }

    updateTriggerStates(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePopup
    );
  } else {
    initializePopup();
  }

  /*
   * Shopify theme editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    initializePopup
  );

  /* --------------------------------------------------
   * Public methods
   *
   * You can also manually open/close the popup:
   *
   * window.iPhoneModelPopup.open();
   * window.iPhoneModelPopup.close();
   * -------------------------------------------------- */
  window.iPhoneModelPopup = {
    open: openPopup,
    close: closePopup
  };
})();